import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";

const _base = "zxAttendanceStudent/";

// 学生考勤表 - 列表查询-分页
export const attendanceMyPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myPage", {
           data: _params,
           method: "GET",
         });
       };
// 学生考勤表 - 新增学生考勤表
export const attendanceAdd = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "add", {
          //  data: Qs.stringify(_params),
           data: _params,
           method: "POST",
         });
       };
// 学生考勤表 - 获取课程直播签到信息
export const attendanceInfo = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "attendance/info", {
           data: _params,
           method: "GET",
         });
       };


// WEBPACK FOOTER //
// ./src/fetch/api/attendance.js